import { Link } from "react-router-dom";
import "./Sidebar.css";
import NavDropdown from "react-bootstrap/NavDropdown";
import NavItem from "./NavItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUsers,
  faFolder,
  faHistory,
  faInfo,
  faEye,
  faHeart,
  faTag,
  faNewspaper,
  faBook,
  faUniversity,
  faTrophy,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import { TagsContext } from "../../context/tag";
import { CategoryContext } from "../../context/categories";
import Cookies from "js-cookie";
import AlertButton from "../Atomics/AttentionButton/AttentionButton";
import { ExhibitionContext } from "../../context/exhibition";
import { SidebarContext } from "../../context/sidebar";
import Breadcrumbs from "../Atomics/Breadcrumb";

const Sidebar = () => {
  const { topTags } = useContext(TagsContext);
  const { categories } = useContext(CategoryContext);
  const { showMenu } = useContext(SidebarContext);
  const sidebarClass = showMenu
    ? "sidebar navbar-nav toggled"
    : "sidebar navbar-nav";

  const [activeItem, setActiveItem] = useState("/");
  const [user, setUser] = useState();
  const { exhibitions } = useContext(ExhibitionContext);
  const [showAlert, setShowAlert] = useState(true);

  const handleNavItemClick = (href) => {
    setActiveItem(href);
  };

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");
    if (user) {
      setUser(user);
    }
  }, []);

  return (
    <>
      {/* <Breadcrumbs /> */}
      <ul style={{ zIndex: "100" }} className={sidebarClass}>
        <NavItem
          href="/"
          faIcon={faHome}
          label="اصلی"
          active={activeItem === "/"}
          onClick={() => handleNavItemClick("/")}
        />
        <NavItem
          href="/channels"
          faIcon={faUsers}
          label="کانال ها"
          active={activeItem === "/channels"}
          onClick={() => handleNavItemClick("/channels")}
        />
        <NavItem
          href="/campaigns/?campaign=true"
          faIcon={faTrophy}
          label="پویش ها"
          active={activeItem === "/campaigns/?campaign=true"}
          onClick={() => handleNavItemClick("/campaigns/?campaign=true")}
        />
        <NavItem
          href="/history"
          faIcon={faHistory}
          label="تاریخچه"
          active={activeItem === "/history"}
          onClick={() => handleNavItemClick("/history")}
        />
        <NavDropdown
          title={
            <>
              <FontAwesomeIcon icon={faFolder} />
              <span style={{ marginRight: "5px" }}> دسته بندی ها</span>
            </>
          }
          id=""
          className="customDropdownStyle no-arrow osahan-right-navbar-user user-dropdown-link"
        >
          {categories.length > 0
            ? categories?.map((item, index) => (
                <Link
                  key={index}
                  to={`/videos/${item.id}`}
                  style={{ textAlign: "right" }}
                  className="dropdown-item"
                  role="button"
                >
                  {item.name}
                </Link>
              ))
            : "دسته بندی ای وجود ندارد."}
        </NavDropdown>
        <NavDropdown
          title={
            <>
              <FontAwesomeIcon icon={faTag} />
              <span style={{ marginRight: "5px" }}>برچسب ها</span>
            </>
          }
          id=""
          className="customDropdownStyle no-arrow osahan-right-navbar-user user-dropdown-link"
        >
          {topTags.length > 0
            ? topTags?.map((item, index) => (
                <Link
                  key={index}
                  to={`/tag-videos/${item.id}`}
                  style={{ textAlign: "right" }}
                  className="dropdown-item"
                  role="button"
                >
                  {item.tag} &nbsp; &nbsp; {item.usage_count}
                </Link>
              ))
            : "دسته بندی ای وجود ندارد."}
        </NavDropdown>
        <NavItem
          href="/liked-videos"
          label="محبوب ترین ها"
          faIcon={faHeart}
          active={activeItem === "/liked-videos"}
          onClick={() => handleNavItemClick("/liked-videos")}
        />
        <NavItem
          href="/popular-videos"
          label="پربازدید ترین ها"
          faIcon={faEye}
          active={activeItem === "/popular-videos"}
          onClick={() => handleNavItemClick("/popular-videos")}
        />
        <NavItem
          href="/blog"
          label="روایت پیشرفت"
          faIcon={faNewspaper}
          active={activeItem === "/blog"}
          onClick={() => handleNavItemClick("/blog")}
        />
        <NavDropdown
          title={
            <>
              <FontAwesomeIcon icon={faUniversity} />
              <span style={{ marginRight: "5px" }}>نمایشگاه ها</span>
            </>
          }
          id=""
          className="customDropdownStyle no-arrow osahan-right-navbar-user user-dropdown-link"
        >
          {exhibitions?.results?.length > 0
            ? exhibitions.results
                .filter(
                  (item) =>
                    item.exhibition_name?.trim() ||
                    item.exhibition_year?.trim(),
                )
                .map((item, index) => (
                  <Link
                    key={index}
                    to={`/exhibition/${item.id}`}
                    style={{
                      textAlign: "right",
                      textWrap: "auto",
                    }}
                    className="dropdown-item"
                    role="button"
                  >
                    {item.exhibition_name?.trim()}{" "}
                    {item.exhibition_year?.trim()}
                  </Link>
                ))
            : "نمایشگاهی وجود ندارد."}
        </NavDropdown>
        {user && (
          <NavItem
            href="/report-problem"
            label="گزارش مشکل"
            faIcon={faInfo}
            active={activeItem === "/report-problem"}
            onClick={() => handleNavItemClick("/report-problem")}
          />
        )}
        <NavItem
          href="/tutorial"
          label="آموزش"
          faIcon={faBook}
          active={activeItem === "/tutorial"}
          onClick={() => handleNavItemClick("/tutorial")}
        />
        {showAlert && (
          <div
            style={{
              display: "flex",
              flexDirection: "column-reverse",
              alignItems: "center",
              position: "fixed",
              bottom: 20,
              right: 20,
              zIndex: 2000,
            }}
          >
            <AlertButton
              href="https://ble.ir/vaghfnama_bot"
              label={
                <>
                  <span className="bot-button-text">
                    در بات وقف نما همراه ما باشید
                  </span>

                  <FontAwesomeIcon
                    icon={faRobot}
                    className="bot-button-icon"
                    aria-hidden="true"
                  />
                </>
              }
            />
            <button
              onClick={() => setShowAlert(false)}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "14px",
                cursor: "pointer",
                color: "#666",
                marginBottom: "-2px",
                outline: "none",
              }}
              aria-label="بستن"
            >
              ×
            </button>
          </div>
        )}
      </ul>
    </>
  );
};

export default Sidebar;
